/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductNatureEnum = {
    Licence: 'licence',
    Maintenance: 'maintenance',
    Cloud: 'cloud'
} as const;
export type ProductNatureEnum = typeof ProductNatureEnum[keyof typeof ProductNatureEnum];


export function instanceOfProductNatureEnum(value: any): boolean {
    for (const key in ProductNatureEnum) {
        if (Object.prototype.hasOwnProperty.call(ProductNatureEnum, key)) {
            if (ProductNatureEnum[key as keyof typeof ProductNatureEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProductNatureEnumFromJSON(json: any): ProductNatureEnum {
    return ProductNatureEnumFromJSONTyped(json, false);
}

export function ProductNatureEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductNatureEnum {
    return json as ProductNatureEnum;
}

export function ProductNatureEnumToJSON(value?: ProductNatureEnum | null): any {
    return value as any;
}

export function ProductNatureEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ProductNatureEnum {
    return value as ProductNatureEnum;
}

